import React from 'react';

interface Props {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

export const ClassChip: React.FC<Props> = ({ label, isSelected, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`cursor-pointer rounded-xl px-3 py-2 ${isSelected ? 'bg-info-surface text-subhead-14 text-primary' : 'bg-popover text-body-14 text-foreground shadow-card hover:bg-hover'}`}
  >
    {label}
  </button>
);
